export const NEWSROOM_LEADERSHIP = [
  { members: [{ name: "Chen Huifen", position: "Editor" }] },
  {
    group: "News & Audience",
    members: [
      { name: "Lee Su Shyan", position: "Associate Editor" },
      { name: "Lee U-Wen", position: "News Editor" },
      {
        name: "Michelle Low",
        position: "Deputy News Editor (Startups & Property)",
      },
      { name: "Janice Heng", position: "Deputy News Editor (Macro & SME)" },
      { name: "Jude Chan", position: "Deputy News Editor (Companies & ESG)" },
      {
        name: "Vivien Shiao",
        position: "Deputy News Editor & Young Audience Editor",
      },
      { name: "Jaime Ee", position: "Lifestyle Editor" },
      { name: "Genevieve Cua", position: "Wealth Editor" },
      { name: "Dennis Chan", position: "Night Editor" },
      { name: "Vivien Ang", position: "Chief Sub-editor" },
      { name: "Natalie Koh", position: "Audience Growth & Strategy Editor" },
      { name: "Alvina Soh", position: "Social Media Editor" },
      { name: "Claressa Monteiro", position: "Head of Audio" },
      { name: "Ang Guangzheng", position: "Head of Video" },
      { name: "Tan Weizhen", position: "Breaking News Editor" },
    ],
  },
  {
    group: "BT Global",
    members: [
      { name: "Ong Hwee Hwee", position: "Associate Editor" },
      { name: "Anita Gabriel", position: "Deputy Editor" },
      { name: "Mindy Tan", position: "Deputy Editor" },
      { name: "Yuling Li", position: "Deputy Opinion Editor" },
      { name: "Lionel Lim", position: "Assistant Editor" },
      { name: "Kai Teo", position: "Head of Growth & Brand" },
    ],
  },
  {
    group: "Product & Engineering",
    members: [{ name: "Atelier Shen", position: "Head of Product" }],
  },
  {
    group: "Revenue & Partnerships",
    members: [{ name: "Lilian Ang", position: "Associate Editor (Revenue)" }],
  },
];
